//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  name: 'product-card-actions',
  components: {
    ButtonFavorite: () => import('./actions/ProductButtonFavorite.vue'),
    ButtonSimilar: () => import('./actions/ProductButtonSimilar.vue'),
    ButtonDownloadSample: () => import('./actions/ProductButtonDownloadSample.vue'),
    ButtonProductPage: () => import('./actions/ProductButtonProductPage.vue'),
    ButtonPin: () => import('./actions/ProductButtonPin.vue'),
  },
  props: {
    element: Object,
    showFavorite: {
      type: Boolean,
      default: true,
    },
    showPin: {
      type: Boolean,
      default: true,
    },
    showSimilar: {
      type: Boolean,
      default: false,
    },
    showDownloadSample: {
      type: Boolean,
      default: false,
    },
    showView: {
      type: Boolean,
      default: true,
    },
    linkUrl: String,
  },
  computed: {
    ...mapState({
      favoritesAddedToday: state => state.favorites.addedToday,
    }),
    favoritesAddedTodayIds() {
      return this.favoritesAddedToday.map(x => x.id);
    },
    mediaType() {
      return _.get(this.element, 'mediaType');
    },
    isAudio() {
      return isProductType('audio', this.mediaType);
    },
    hasSample() {
      return !!_.get(this.element, 'sample');
      // if (!this.element) {
      //   return false;
      // }
      // // if no preview
      // if (!_.size(this.element.previews)) {
      //   return false;
      // }
      //
      // return ['photo', 'photo_vr'].includes(this.mediaType)
      //     || isProductType('video', this.mediaType)
      //     || isProductType('audio', this.mediaType)
      //     || isProductType('video_template', this.mediaType);
    },
    isSimilaritySearchEnabled() {
      return _.get(this.element, 'similarity');
    },
  },
};
